module.exports = __webpack_public_path__ + "img/atom.81cf646a.svg";